import React from "react";
import { Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { BreadCrumbItem } from "../../organisms/HeaderSection";
import Page from "../../organisms/Page";
import TableSection from "./TableSection";

const breadCrumbs: BreadCrumbItem[] = [
  {
    path: "/",
    label: "Inicio",
  },
  {
    path: "/asistencia",
    label: "Asistencia",
  },
  {
    path: "/checkin",
    label: "Check in",
    isActive: true,
  },
];

function EditarCheckinAsistencia() {
  let { idLista } = useParams();
  return (
    <Page
      title="Check-in diario"
      description="Registro de asistencia mascotas programadas para el día de hoy."
      breadCrumbs={breadCrumbs}
    >
      <Row className="justify-content-center">
        <div className="col-xs-12 col-md-10 col-lg-10 col-xxl-7">
          <TableSection idLista={idLista!!} />
        </div>
      </Row>
    </Page>
  );
}

export default EditarCheckinAsistencia;
